module.exports = __webpack_public_path__ + "static/media/bollettini.1032b735.svg";